import {eatClubClient} from "@globals/config/apiClient";

import {DishDetailsItem} from "./interfaces";

export function fetchDishDetails(
  operatorSlug: string,
  slug: string
): Promise<DishDetailsItem> {
  return eatClubClient
    .get(`/api/items/${operatorSlug}/${slug}/`)
    .then((response) => response.data)
    .catch(({response}) => {
      const error = {
        status: response.status,
        message: response.data?.message,
      };
      throw error;
    });
}
